import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MerchantService, NotificationService, UiDefaults } from '@odin/odin-core';

/**
 * Lets a user manage their identity-level UI defaults (currently just the
 * new transaction experience opt-in). Self-service only: the endpoint takes
 * the user from the auth token, so the section is hidden on other profiles.
 */
@Component({
  selector: 'odin-ui-defaults-configurator',
  standalone: false,
  templateUrl: './ui-defaults-configurator.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ui-defaults-configurator.component.css',
})
export class UiDefaultsConfiguratorComponent {
  @Input() public isSelf: boolean = false;

  public loading: boolean = false;

  constructor(
    private merchantService: MerchantService,
    private notificationService: NotificationService,
  ) { }

  public get newTransactionExperience(): boolean | undefined {
    const value = this.merchantService.getUserprofile()?.uiDefaults?.newTransactionExperience;
    return value === null ? undefined : value;
  }

  public get hasChosen(): boolean {
    return this.newTransactionExperience !== undefined;
  }

  public setNewTransactionExperience(enabled: boolean): void {
    if (this.loading) return;
    this.loading = true;

    const defaults: UiDefaults = { newTransactionExperience: enabled };
    this.merchantService.SetUiDefaults(defaults, (updated: boolean, error?: unknown) => {
      this.loading = false;
      if (updated) {
        this.notificationService.SmallDialog('UI defaults updated.', 'Close', 3000);
      } else {
        const message = 'Failed to update UI defaults';
        this.notificationService.ErrorSmallDialog(message, error ?? new Error(message));
      }
    });
  }
}
